module.exports = __webpack_public_path__ + "static/media/btn_arrow_left_gray.0713be90.svg";